import React, { useState } from "react";
import Box from "@material-ui/core/Box";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import Typography from "@material-ui/core/Typography";
import Information20 from "@carbon/icons-react/lib/information/20";
import Close32 from "@carbon/icons-react/lib/close/32";
import sectionDefinitionsStyles from "../styles/SectionDefinitions.styles";

/**
 * The info affordance beside a section heading (PSTATS-1267).
 *
 * One icon per section rather than one per field: a crew reading the form
 * wants the section's vocabulary, and a row of icons down the form competes
 * with the fields for attention. It replaces the per-field popover the first
 * pass shipped.
 *
 * A Dialog, not a popover. It closes on a backdrop click, on Esc and on its
 * own close button - MUI's onClose covers the first two, so all three routes
 * out come for free rather than being hand-wired.
 *
 * A section with nothing defined renders no icon at all. An icon that opens an
 * empty dialog is worse than no icon, and tennis defines no descriptions.
 */
const SectionDefinitions = ({ sectionTitle, ruleSetName, entries = [] }) => {
	const classes = sectionDefinitionsStyles();
	const [open, setOpen] = useState(false);

	if (!entries.length) {
		return null;
	}

	const close = () => setOpen(false);

	return (
		<>
			<IconButton
				className={classes.trigger}
				size="small"
				aria-label={`What do the ${sectionTitle} settings mean?`}
				onClick={() => setOpen(true)}
			>
				<Information20 />
			</IconButton>
			<Dialog open={open} onClose={close} maxWidth="sm" fullWidth scroll="paper">
				<DialogTitle disableTypography>
					<Typography variant="h5" className={classes.title}>
						{sectionTitle}
					</Typography>
					{ruleSetName && (
						<Typography variant="body2" color="textSecondary">
							{ruleSetName}
						</Typography>
					)}
					<IconButton className={classes.close} aria-label="Close" onClick={close}>
						<Close32 />
					</IconButton>
				</DialogTitle>
				<DialogContent dividers>
					{entries.map(({ key, title, description, value }) => (
						<Box key={key} className={classes.row}>
							<Box>
								<Typography variant="subtitle2" className={classes.term}>
									{title}
								</Typography>
								<Typography
									variant="body2"
									color="textSecondary"
									className={classes.value}
								>
									{String(value)}
								</Typography>
							</Box>
							<Typography variant="body2">{description}</Typography>
						</Box>
					))}
				</DialogContent>
			</Dialog>
		</>
	);
};

export default SectionDefinitions;
